import { desc, image, title } from 'framer-motion/client';
import { imagePath } from '../../../../utils/imagePath';

export const trandingTopics = [
  {
    title: 'Using MCP(Model Context Protocol) in Spatial Grid platform',
    intro: 'Using the Model Context Protocol (MCP)\nFrom the Dashboard page:',
    steps: [
      {
        step: 'Step 1: Click on the Search bar',
        bullets: [
          'On the dashboard page, click the Search, add, generate or ask anything field at the top.',
        ],
        image: imagePath?.McpSearch,
      },
      {
        step: 'Step 2: Enter Your Prompt',
        bullets: [
          'Type what 3D asset you want (e.g., "Add a modern house exterior 3D model," "Add solar panels model," etc.)..',
        ],
        image: imagePath?.CreateExperience,
      },
      {
        step: 'Step 3:  Generate the Asset',
        bullets: [
          'Submit the prompt.',
          'MCP processes your request and fetches the 3D model or asset.',
          'The model appears in your project or scene.',
        ],
        image: imagePath?.GenerateAssets,
      },
      {
        step: 'Step 4:   Use the Asset',
        bullets: [
          'Open the project in the grid.',
          'Place and adjust the model within the grid or scene as required.',
          'The model appears in your project or scene.',
        ],
        image: imagePath?.UseAssets,

        subSections: [
          {
            title: 'Inside the Grid/Project:',
            points: ['Find the Search option inside your project.'],
            image: imagePath?.GridProject,
          },
          {
            title: '',
            points: [
              'Enter a prompt describing the 3D model you want (e.g., “Add a bugatti model to the scene”).',
              'Submit it, and the 3D model pops right onto the grid.',
            ],
            image: imagePath?.ThreeDModel,
          },
        ],
      },
    ],
  },
  {
    title: 'Sharing Projects with External Users',
    intro: '',
    steps: [
      {
        step: 'Step 1: Create a New Project',
        bullets: [
          'Log in to the platform.',
          'Navigate to the Dashboard.',
          'Click on Create New Project.',
        ],
        image: imagePath?.NewProject,
        bulletsAfter: [
          'Enter the required project details:',
          'Click Create to initialize the project.',
        ],
      },
      {
        step: 'Step 2:  Add Required Assets',
        bullets: [
          'Open the project workspace.',
          'Navigate to the Assets',
          'Upload new assets or select from the existing Elements.',
          'Confirm that the assets appear in the project panel and on the grid.',
          'Publish changes after placement.',
        ],
        image: imagePath?.RequiredAssets,
        description:
          'Ensure all required objects, models, or elements are properly positioned before moving to preview.',
      },
      {
        step: 'Step 3: Go to the Preview Section',
        subSections: [
          {
            title: '',
            points: [
              {
                text: 'Click the Preview button in the top toolbar to see a live version.',
              },
            ],
            image: imagePath?.Preview,
            bulleted: false,
          },
          {
            title: '',
            points: [
              {
                text: 'Review the scene to ensure:',
                subPoints: [
                  'Assets are visible and correctly placed',
                  'Grid behavior functions as expected',
                  'No visual or placement issues are present',
                ],
              },
            ],
            bulleted: false,
          },
        ],
      },
      {
        step: 'Step 4: Share the Project with External Users',
        bullets: [],
        image: null,
        subSections: [
          {
            points: [
              {
                text: 'While youre in the Preview section, click the Share option.',
              },
            ],
            image: imagePath?.Share,
          },
          {
            points: [
              {
                text: 'You can either Generate a shareable link or Invite via email.',
                subPoints: [
                  'Copy the link and share it, External users can check out the preview without being actual team members.',
                ],
              },
            ],
            image: imagePath?.Share2,
          },
        ],
      },
    ],
  },
  {
    title: 'Publishing for Mobile(AR)/VR/MR',
    intro: '',
    steps: [
      {
        step: ' 1 : For VR Training:',
        bullets: [
          'When you hit Publish, you get a unique 6-character Experience Code.',
          'Share this code—users enter it on the "Enter Experience Code" screen to load the VR experience securely.',
        ],
        image: imagePath?.VRPublish,
      },
      {
        step: ' 2 : For Mobile(AR) Experience:',
        bullets: [
          'Publishing an AR project generates a QR code for super quick access.',
          'Users just scan the QR code with their mobile device to open the AR experience instantly.',
          'Users can also download the QR, copy the Public URL, or get an Embed Link for websites.',
        ],
        image: imagePath?.ARPublish,
      },
      {
        step: 'Additional Options',
        bullets: [
          'Download QR to share externally.',
          'Copy the Public URL for direct access.',
          'Use the Embed Link to integrate the experience into a website.',
          'Use the Spatial Grid ID for internal reference or tracking',
        ],
        image: imagePath?.ARPublish,
      },
    ],
  },
  {
    title: 'VR Flow document creation',
    intro:
      'Follow the steps below to access the Training section and upload documents for VR use.',
    steps: [
      {
        step: 'Step 1: Log In',
        bullets: [
          'Open the platform login page.',
          'Enter your registered credentials.',
          'Click Login to access the dashboard.',
        ],
        image: null,
      },
      {
        step: 'Step 2: Navigate to the Training Section',
        bullets: [
          'Once logged in, locate the left-side panel.',
          'Find and click on Training.',
        ],
        image: imagePath?.TrainingSection,
        bulletsAfter: ['The Training page will open.'],
      },
      {
        step: 'Step 3: Step 3: Upload Documents for VR',
        bullets: [
          'On the Training page, locate the Upload option.',
          'Click Upload Documents.',
        ],
        image: imagePath?.UploadDocument,
        bulletsAfter: [
          'Select the required files from your system.',
          'Confirm the upload.',
          'Wait for the upload process to complete.',
          'Click process input',
        ],
        imageAfter: imagePath?.ProcessInput,
      },
      {
        step: 'Step 4: Review and Edit',
        description:
          'After processing the uploaded content, the system moves to Review and Edit.',
        bullets: [
          ' Check the structured training content created from your uploaded files and text input.',
          ' Modify titles, descriptions, instructions, or sequence as needed to match your ',
          ' Ensure the content is logically organized and ready for VR experience generation.',
        ],
        image: imagePath?.ReviewEdit,
        bulletsAfter: ['Save your edits before proceeding to the next step.'],
      },
      {
        step: 'Step 5: Team Setup',
        description:
          'In this step, you configure the AI agents responsible for generating the VR training experience.',
        bullets: [
          ' Roles such as LXD, Researcher, Concept Designer, and Moment Writer are predefined.',
          '  Choose the required model (e.g., gpt-4o) for each role.',
          ' Click Save to apply the settings before moving to the next step.',
          'You may also use Load, Export, Import, or Reset if needed.',
        ],
        image: imagePath?.TeamSetup,
      },
      {
        step: 'Step 6: Select Assets',
        bullets: [],
        subSections: [
          {
            title: '1. Analyze Documents',
            points: [
              { text: 'Click Analyze Documents.' },
              {
                text: 'The system scans uploaded files to identify required assets.',
              },
              { text: 'Identified items will appear under Analyzed Assets.' },
            ],
            bulleted: true,
            image: null,
          },
          {
            title: '2. Load Assets',
            points: [
              {
                text: 'You can add assets in three ways:',
                subPoints: [
                  'Click Browse & Select Assets to choose from the library OR',
                  'Manually enter an asset name and click Add to Loaded Assets OR',
                  'Can use the assets which are analyzed assets from the documents',
                ],
              },
            ],
            bulleted: false,
            image: imagePath?.SelectAsset,
          },
          {
            title: '3. Map Required Assets',
            points: [
              { text: 'There are two ways assets are mapped:' },
              {
                text: 'Auto Mapping (Fetch & Add)',
                subPoints: [
                  'When you click Fetch & Add on an analyzed asset, it is automatically added to the Required / Mapped Assets section.',
                  'The mapped count updates automatically.',
                  'No drag-and-drop is required.',
                ],
              },
              {
                text: 'Manual Mapping',
                subPoints: [
                  'If you add assets manually using Browse & Select Assets or Manual Entry, the asset is first added to the loaded list.',
                  'You must then drag and drop the asset into the Required Assets section.',
                  'Once dropped, it is marked as mapped.',
                ],
              },
              {
                text: 'Ensure all necessary assets are mapped before proceeding.',
              },
            ],
            bulleted: false,
            image: null,
          },
          {
            title: '4. Review Analyzed Assets',
            points: [
              { text: 'Mandatory assets are listed under Analyzed Assets.' },
              {
                text: 'Each asset shows its type (e.g., mesh) and status (Needed).',
              },
              { text: 'Click Fetch & Add to load the asset.' },
            ],
            bulleted: true,
            image: imagePath?.AnalyzedAssets,
            pointsAfter: [
              {
                text: 'Or click Upload if the asset is not available in the system.',
              },
              {
                text: 'After you done this click Generate story to proceed to next step.',
              },
            ],
          },
        ],
      },
      {
        step: 'Step 7: Story Board',
        description:
          'After mapping assets, the system generates the storyboard.',
        bullets: [],
        subSections: [
          {
            title: 'Generate Story (Non-Technical Storyboard)',
            points: [
              {
                text: '1. Open Storyboard — The training is organized into Chapters, and each chapter contains multiple Moments.',
              },
              {
                text: '2. Select Non-Technical Mode — Ensure Non-Technical is selected for a simplified, user-friendly view.',
              },
              {
                text: '3. Review Chapters & Moments — Click on a chapter to view its moments and review details such as Overview, Before Touch, After Touch, and Voice instructions.',
              },
              {
                text: '4. Edit if Needed — Modify content or flow as required.',
              },
              {
                text: '5. Publish — Click Publish once the storyboard is finalized.',
              },
            ],
            bulleted: false,
            image: imagePath?.PublishStoryBoard, // ← replace with your image key
          },
          {
            title: 'Generate Story (Technical Storyboard)',
            points: [
              {
                text: 'Switch to Technical mode to view the logic flow behind each moment.',
              },
              {
                text: '1. Select Technical Mode — Click Technical at the top right to open the node-based workflow view.',
              },
              {
                text: '2. View Chapters & Moments — The left panel shows all Chapters and their corresponding Moments.',
              },
              {
                text: '3. Review Logic Flow — Each moment displays a visual flow including:',
                subPoints: [
                  'Start / On Awake',
                  'Voice Over',
                  'Objects',
                  'Proximity',
                  'Interaction triggers',
                ],
              },
              {
                text: '4. Edit Nodes (If Required) — Click Edit on any node to modify logic, queries, or behavior.',
              },
              {
                text: '5. Publish — Once validated, click Publish to finalize the training experience.',
              },
            ],
            bulleted: false,
            image: imagePath?.PublishTrainingExperience, // ← replace with your image key
          },
        ],
      },
      {
        step: 'Step 8: View Assets on Grid',
        description:
          'After clicking Publish, the training experience is finalized.',
        bullets: [],
        subSections: [
          {
            title: '1. Open the Scene / Grid View',
            points: [{ text: 'Navigate back to the Scene Editor.' }],
            bulleted: false,
            image: null,
          },
          {
            title: '2. Assets Appear on the Grid',
            points: [
              {
                text: 'All mapped and required assets are automatically placed within the Spatial Grid.',
              },
            ],
            bulleted: false,
            image: imagePath?.AssetsOnGrid,
          },
          {
            title: '3. Verify Placement',
            points: [
              {
                text: 'Confirm that:',
                subPoints: [
                  'Mandatory assets are visible',
                  'Objects are positioned correctly',
                  'Interactions function as configured',
                ],
              },
            ],
            bulleted: false,
            image: imagePath?.VRAssets,
            pointsAfter: [
              {
                text: 'The VR training environment is now fully generated and visually represented on the Spatial Grid Platform.',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    title: 'How to switch experiences on grid',
    steps: [
      {
        step: 'VR → AR Mode Switch',

        description:
          'When a user switches from VR to AR, the system transitions from a fully immersive virtual environment to a real-world camera-based augmented experience.',
        image: imagePath?.VRARConvert,
        subSections: [
          {
            title: 'User Flow',
            bulleted: true,
            points: [
              'The user selects AR from the Experience Mode Selector.',
              'Switch Experience Mode confirmation modal appears.',
              '“What Will Change” information modal is shown.',
              'Experience Load Notice is displayed.',
              'User clicks Confirm & Switch.',
              'The system initializes AR mode.',
            ],
            image: imagePath?.VRARSwitch,
          },

          {
            title: 'What Changes (VR → AR)',
            bulleted: true,
            points: [
              'VR immersive view is disabled',
              'Device camera feed is enabled',
              'Headset view is removed',
              'Tracking switches to camera-based',
              'AR loads faster compared to VR',
            ],
            image: imagePath?.VRARWillChange,
          },

          {
            title: 'AR Tracking Modes',
            bulleted: true,
            points: [
              'Surface – Anchors content to flat surfaces',
              'World – Tracks environment objects and space',
              'Location – Uses GPS-based triggers',
            ],
            image: imagePath?.VRARTrackingMode,
          },
        ],
      },
      {
        step: 'VR → MR Mode Switch',

        description:
          'Switching from VR to MR transitions from a fully virtual immersive environment to a mixed environment where digital content interacts with the real world.',
        image: imagePath?.VRMRConvert,
        subSections: [
          {
            title: 'User Flow',
            bulleted: true,
            points: [
              'The user selects MR while in VR mode.',
              'Switch Experience Mode modal appears.',
              '“What Will Change” modal is displayed.',
              'Experience Load Notice is shown.',
              'User clicks Confirm & Switch.',
              'MR mode initializes.',
            ],
            image: imagePath?.VRMRSwitch,
          },

          {
            title: 'What Changes (VR → MR)',
            bulleted: true,
            points: [
              'Mixed real + virtual view enabled',
              'Surface tracking activated',
              'Anchors become active',
              'Rendering load reduced compared to VR',
            ],
            image: imagePath?.VRMRWillChange,
          },

          {
            title: 'Experience Load Notice',
            bulleted: true,
            points: [
              'MR is lighter than VR',
              'Works well on most devices',
              'Requires high-end phone or desktop',
            ],
            image: imagePath?.VRMRLoadNotice,
          },
        ],
      },
      {
        step: 'VR → XR Mode Switch',

        description:
          'Switching from VR to XR enables a flexible cross-reality runtime supporting immersive and real-world blended experiences.',
        image: imagePath?.VRXRConvert,
        subSections: [
          {
            title: 'User Flow',
            bulleted: true,
            points: [
              'User selects XR while in VR mode.',
              'Switch Experience Mode modal appears.',
              '“What Will Change” modal is displayed.',
              'Experience Load Notice is shown.',
              'User clicks Confirm & Switch.',
              'XR mode initializes.',
            ],
            image: imagePath?.VRXRSwitch,
          },

          {
            title: 'What Changes (VR → XR)',
            bulleted: true,
            points: [
              'Partial real-world view enabled',
              'Camera and sensors activated',
              'Surface tracking enabled',
              'Rendering load adjusted (lighter than VR)',
            ],
            image: imagePath?.VRXRWillChange,
          },

          {
            title: 'Experience Load Notice',
            bulleted: true,
            points: [
              'XR runs slightly lighter than VR',
              'Adapts quickly on capable devices',
              'Requires high-end phone or desktop',
            ],
            image: imagePath?.VRXRLoadNotice,
          },
        ],
      },
      {
        step: 'AR → VR Mode Switch',

        description:
          'Switching from AR to VR transitions from camera-based augmented view to a fully immersive virtual environment.',
        image: imagePath?.ARVRConvert,
        subSections: [
          {
            title: 'User Flow',
            bulleted: true,
            points: [
              'The user selects AR while in VR mode.',
              'Switch Experience Mode modal appears.',
              '“What Will Change” modal is displayed.',
              'Experience Load Notice is shown.',
              'User clicks Confirm & Switch.',
              'XR mode initializes.',
            ],
            image: imagePath?.ARVRSwitch,
          },

          {
            title: 'What Changes (AR → VR)',
            bulleted: true,
            points: [
              'Camera-based tracking is disabled',
              'Surface anchors are reset ',
              'VR headset view is enabled',
              'Lighting adapts to virtual environment',
              'Immersive rendering activated',
            ],
            image: imagePath?.ARVRWillChange,
          },

          {
            title: 'Experience Load Notice',
            bulleted: true,
            points: [
              'VR mode is heavier than AR',
              'May take longer to load',
              'Requires VR-ready GPU or headset',
            ],
            image: imagePath?.ARVRLoadNotice,
          },
        ],
      },
      {
        step: 'AR → MR Mode Switch',

        description:
          'Switching from AR to MR upgrades from basic camera tracking to spatially aware mixed reality.',
        image: imagePath?.ARMRConvert,
        subSections: [
          {
            title: 'User Flow',
            bulleted: true,
            points: [
              'The user selects MR while in AR mode.',
              'Switch Experience Mode modal appears.',
              '“What Will Change” modal is displayed.',
              'Experience Load Notice is shown.',
              'User clicks Confirm & Switch.',
              'MR mode initializes.',
            ],
            image: imagePath?.ARMRSwitch,
          },

          {
            title: 'What Changes (AR → MR)',
            bulleted: true,
            points: [
              'Depth and occlusion enabled',
              'Surface detection enhanced',
              'Anchors and tracking remain active',
              'Scene interaction becomes more advanced',
            ],
            image: imagePath?.ARMRWillChange,
          },

          {
            title: 'Experience Load Notice',
            bulleted: true,
            points: [
              'MR is slightly heavier than AR',
              'Loads quickly on most devices',
              'Depth sensors preferred',
            ],
            image: imagePath?.ARMRLoadNotice,
          },
        ],
      },
      {
        step: 'MR → VR Mode Switch',

        description:
          'Switching from MR to VR removes real-world blending and loads a fully virtual immersive experience.',
        image: imagePath?.MRVRConvert,
        subSections: [
          {
            title: 'User Flow',
            bulleted: true,
            points: [
              'The user selects VR while in MR mode.',
              'Switch Experience Mode modal appears.',
              '“What Will Change” modal is displayed.',
              'Experience Load Notice is shown.',
              'User clicks Confirm & Switch.',
              'VR mode initializes.',
            ],
            image: imagePath?.MRVRSwitch,
          },

          {
            title: 'What Changes (MR → VR)',
            bulleted: true,
            points: [
              'Full digital immersive view enabled',
              'Physical world tracking disabled',
              'Controller-based input activated',
              'Higher scene realism applied',
            ],
            image: imagePath?.MRVRWillChange,
          },

          {
            title: 'Experience Load Notice',
            bulleted: true,
            points: [
              'VR is more resource-intensive',
              'May take longer to load',
              'Requires WebXR-compatible browser',
            ],
            image: imagePath?.MRVRLoadNotice,
          },
        ],
      },
    ],
  },
  {
    title: 'What is spatial behaviour mapping',
    redirectTo: '/documentation/analytics', // ✅ custom redirect
    redirectAnchor: 'interaction-heatmap-&-behavior-analysis',
  },
];
